/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import React, {ReactNode} from 'react';
import Props from './Props';
import State from './State';
import {Button, Col, FormText, ProgressBar, Row} from 'react-bootstrap';
import styles from './styles';
import {css} from 'aphrodite/no-important';
import PasswordField from '../PasswordField';
import FormGroup from '../FormGroup';
import FormControl from '../FormControl';
import {passwordStrengthText, progressBarVariantForPasswordStrength} from '../../model/password';

class EnterPassword extends React.Component<Props, State> {

	static defaultProps: Props = {
		email: '',
		minimumStrength: 0,
		onPasswordChange: () => {
			// do nothing
		},
		onSubmitPassword: () => {
			// do nothing
		},
		strength: 0,
		submitDisabled: false,
		violations: []
	};

	constructor(props: Props) {
		super(props);

		this.state = {password: ''};
	}

	handlePasswordChange = (password: string): void => {
		const props: Readonly<Props> = this.props;

		this.setState({password});

		props.onPasswordChange(password);
	};

	handleSubmitPassword = (): void => {
		const props: Readonly<Props> = this.props;
		const state: Readonly<State> = this.state;

		if (props.strength < props.minimumStrength)
			return;

		if (!props.submitDisabled)
			props.onSubmitPassword(state.password);
	};

	render(): ReactNode {
		const props: Readonly<Props> = this.props;
		const state: Readonly<State> = this.state;

		return (
			<React.Fragment>
				<FormGroup controlId="email" label="E-mail:">
					<FormControl
						type="email"
						name="email"
						autoFocus={false}
						value={props.email}
						className={css(styles.disabledFormControl)}
						readOnly={true}/>
				</FormGroup>
				<PasswordField
					autoComplete={'new-password'}
					autoFocus={true}
					onChange={this.handlePasswordChange}
					onEnter={this.handleSubmitPassword}
					password={state.password}
					violations={props.violations}/>
				<Row className={css(state.password.length === 0 && styles.progressBarHidden)}>
					<Col xs={12}>
						<ProgressBar
							className={css(styles.progressBar)}
							variant={progressBarVariantForPasswordStrength(props.strength)}
							now={props.strength * 25}/>
						<Row>
							<Col xs={6}>
								{props.strength < props.minimumStrength &&
								<FormText as="div" className={css(styles.helpBlockFeedback)}><p>{'Niet toegestaan'}</p></FormText>}
							</Col>
							<Col xs={6}>
								<FormText as="div" className={css(styles.helpBlockStrength)}>
									<p>{passwordStrengthText(props.strength)}</p></FormText>
							</Col>
						</Row>
					</Col>
				</Row>
				<Button
					type="submit"
					className="float-end"
					variant="primary"
					onClick={this.handleSubmitPassword}
					disabled={props.submitDisabled || props.strength < props.minimumStrength}>
					{'Wachtwoord wijzigen'}
				</Button>
			</React.Fragment>
		);
	}
}

export default EnterPassword;
